(function () {
  function initDreamKitLanding() {
    document.body.classList.add('template-product--dream-kit-landing');

    var configurator = document.querySelector('[data-dk-configurator]') || document.querySelector('#shopify-section-main');
    var productForm = configurator && configurator.querySelector('[data-dk-product-form], [data-product-form]');
    var originalButton = productForm && productForm.querySelector('[data-dk-add-to-cart], .product-form--atc-button');
    var stickyBar = document.querySelector('[data-dk-sticky-cart]');
    var stickyButton = stickyBar && stickyBar.querySelector('[data-dk-sticky-button]');
    var stickyPrice = stickyBar && stickyBar.querySelector('[data-dk-sticky-price]');
    var productPrice = configurator && configurator.querySelector('[data-dk-configurator-price], [data-price]');

    if (configurator) {
      var variantDataElement = configurator.querySelector('[data-dk-variant-data]');
      var optionSelectors = Array.from(configurator.querySelectorAll('[data-dk-option-index]'));
      var variantIdInput = configurator.querySelector('[data-dk-variant-id]');
      var currentPrice = configurator.querySelector('[data-dk-current-price]');
      var comparePrice = configurator.querySelector('[data-dk-compare-price]');
      var variantStatus = configurator.querySelector('[data-dk-variant-status]');
      var mainImage = configurator.querySelector('[data-dk-main-image]');
      var variants = [];

      if (variantDataElement) {
        try {
          variants = JSON.parse(variantDataElement.textContent);
        } catch (error) {
          variants = [];
        }
      }

      function updateVariant(variant, updateUrl) {
        if (!variant || !variantIdInput || !originalButton) return;

        variantIdInput.value = variant.id;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (currentPrice) currentPrice.textContent = variant.price;

        if (comparePrice) {
          comparePrice.textContent = variant.compareAtPrice;
          comparePrice.hidden = !variant.showCompareAtPrice;
        }

        originalButton.disabled = !variant.available;
        originalButton.textContent = variant.available
          ? originalButton.dataset.availableLabel
          : originalButton.dataset.unavailableLabel;

        if (variantStatus) {
          variantStatus.textContent = variant.available
            ? 'In stock and ready to order.'
            : 'This combination is currently unavailable.';
        }

        if (mainImage && variant.image) {
          mainImage.src = variant.image;
          mainImage.removeAttribute('srcset');
          mainImage.alt = variant.imageAlt || mainImage.alt;
        }

        if (updateUrl && window.history && window.URL) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      function findSelectedVariant() {
        var selectedOptions = optionSelectors.map(function (select) {
          return select.value;
        });

        return variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });
      }

      optionSelectors.forEach(function (select) {
        select.addEventListener('change', function () {
          updateVariant(findSelectedVariant(), true);
        });
      });

      configurator.querySelectorAll('[data-dk-thumbnail]').forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          configurator.querySelectorAll('[data-dk-thumbnail]').forEach(function (item) {
            item.classList.remove('is-active');
          });
          thumbnail.classList.add('is-active');

          if (mainImage) {
            mainImage.src = thumbnail.dataset.imageSrc;
            mainImage.removeAttribute('srcset');
            mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
          }
        });
      });

      var requestedVariantId = new URL(window.location.href).searchParams.get('variant');
      var requestedVariant = variants.find(function (variant) {
        return String(variant.id) === requestedVariantId;
      });

      if (requestedVariant) {
        optionSelectors.forEach(function (select, index) {
          select.value = requestedVariant.options[index];
        });
        updateVariant(requestedVariant, false);
      }
    }

    document.querySelectorAll('[data-dk-scroll-to-configurator]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!configurator) return;
        event.preventDefault();
        configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (stickyButton && originalButton) {
      stickyButton.addEventListener('click', function () {
        var disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';

        if (disabled) {
          configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        originalButton.click();
      });
    }

    function syncStickyState() {
      if (!stickyButton || !originalButton) return;

      var originalText = originalButton.textContent.trim();
      stickyButton.textContent = originalText || stickyButton.dataset.defaultLabel;
      stickyButton.disabled = originalButton.disabled;

      if (stickyPrice && productPrice) {
        stickyPrice.innerHTML = productPrice.innerHTML;
      }
    }

    if (configurator && stickyBar) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.08 });

      observer.observe(configurator);
    }

    if (configurator) {
      configurator.addEventListener('change', function () {
        window.setTimeout(syncStickyState, 50);
      });

      var mutationObserver = new MutationObserver(syncStickyState);
      mutationObserver.observe(configurator, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }

    syncStickyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDreamKitLanding, { once: true });
  } else {
    initDreamKitLanding();
  }
})();
